import InspectionSignaturesList from "./InspectionSignaturesList.vue";
import Inspectors from "../../mixins/inspectorAccess.js";

Vue.component("inspection-update-form", {

    mixins: [Inspectors],
    components: {InspectionSignaturesList},

    props: {
        inspection: {},
        inspectionTypes: {
            type: Array
        },
    },

    data () {
        return {
            form: new AppForm({
                comments: this.inspection.comments,
                inspector_id: this.inspection.inspector_id,
                asset_id: this.inspection.asset_id,
                date: this.inspection.date_only,
                time: this.inspection.time,
                type: this.inspection.type,
                status: this.inspection.status
            }),
            selectedInspector: {
                id: this.inspection.inspector_id,
                name: this.inspection.inspector_name,
                user_portfolio_access: true // Default to true to avoid showing the inspector as false while page is loading
            },
            selectedAsset: this.inspection.asset,
            loading: false,
            copiedInspection: this.inspection.copied_inspection,
        };
    },

    computed: {
        uploadedStatusClass () {
            return {
                "btn-primary text-white": this.isStatus("uploaded"),
                "btn-outline-primary": !this.isStatus("uploaded"),
                "disabled-segment no-hover": _.isEmpty(this.inspection.uploaded_at)
            };
        },
    },

    watch: {
        inspection: function () {
            this.setFormValues();
        },
    },

    mounted () {
        this.fetchInspectors(this.selectedInspector.name);
        let self = this;
        Bus.$on("inspection-completed", function (inspection) {
            if (self.inspection.id === inspection.id) {
                self.form.status = "completed";
                self.saveInspection();
            }
        });
    },

    methods: {
        setFormValues () {
            this.form.comments = this.inspection.comments;
            this.form.inspector_id = this.inspection.inspector_id;
            this.form.asset_id = this.inspection.asset_id;
            this.form.date = this.inspection.date_only;
            this.form.time = this.inspection.time;
            this.form.type = this.inspection.type;
            this.form.status = this.inspection.status;
        },

        saveInspection () {
            this.form.inspector_id = this.selectedInspector ? this.selectedInspector.id : null;

            App.patch("/inspections/" + this.inspection.id + "/update", this.form)
            .then((response) => {
                Bus.$emit("inspection-updated", response);
                window.toastr.success("Saved!");
            });
        },

        isStatus (status) {
            return this.form.status === status;
        },

        setStatus (status) {
            if (this.inspection.status === status) {
                return;
            }

            if (status === "uploaded" && _.isEmpty(this.inspection.uploaded_at)) {
                return;
            }

            if (status === "scheduled") {
                let self = this;
                swal({
                    title: "Schedule Inspection",
                    text: "Changing the inspection status to scheduled will make the inspection available to be downloaded to the app. Continue?",
                    showCancelButton: true
                }).then((result) => {
                    if (result.value) {
                        self.form.status = status;
                        self.saveInspection();
                    }
                });
                return;
            }
            this.form.status = status;
            this.saveInspection();
        },
    },
});
